// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxesPlaceholder_container__2wPKE","wrapper":"CheckboxesPlaceholder_wrapper__2LCRI"};